import React, { useEffect, useState } from 'react'
import _ from 'lodash'
import { useNavigate } from 'react-router-dom'

import AddBeneficiaryPersonalDataForm from './components/AddBeneficiaryPersonalDataForm'
import beneficiary from '../../gql/beneficiary'
import PatientDetailForm from './components/PatientDetailForm'
import { Tooltip } from '@mui/material'

function BeneficiaryForm ({}) {
  const navigate = useNavigate()
  const [chiReqRecord, setChiReqRecord] = useState(null)
  const [systemType, setSystemType] = useState(null)

  return (
    <div className='superGit_container'>
      <div class='benefeciary-create'>
        <PatientDetailForm
          setChiReqRecord={setChiReqRecord}
          setSystemType={setSystemType}
        />
        <AddBeneficiaryPersonalDataForm
          item={null}
          chiReqRecord={chiReqRecord}
          setChiReqRecord={setChiReqRecord}
          systemType={systemType}
        />
      </div>
    </div>
  )
}

export default BeneficiaryForm
